<!--
  TODO (cleanup): To utilize this utility component to replace the similar-inspirer `OrientationEditor` in `@/views/PlayerEditorView/OrientationEditor/OrientationEditor.vue`.
-->

<template>
  <Dialog :expanderClass="'d-inline'" ref="dialogRef">
    <template #expander="{ openModal }">
      <a :class="['orientation-link font-bold', {'with-btn-title': btnTitle}]" @click="openModal">
        {{ btnTitle ?? selectedOrientationName }}
      </a>
    </template>
    <template #dialog.title>{{ dialogTitle }}</template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <p> {{ dialogSubtitle }}</p>
      <!-- TODO (cleaner code): think about removing redundancy between "DeleteItemConfirmationForm" & other forms (e.g. CreateSlideForm) [DSP-N26Dui5A] -->
      <div class="delete-item-form">
        <div class="d-flex">
          <div
            v-for="orientationOption of orientationOptions"
            :key="orientationOption.value"
          >
            <div
              :class="[
                'orientation-editor ml-2 px-2 py-4',
                { 'active': selectedOrientation.value == orientationOption.value }
              ]"
              @click="selectOrientation(orientationOption)"
            >
              <div
                :class="[
                  'orientation-lable m-auto',
                  { 'portrait': orientationOption.classes == 'portrait', 'rotate-180': orientationOption.value > 90 }
                ]"
              >
                <p> {{ orientationOption.label }}</p>
              </div>
              <p> {{ orientationOption.name }} </p>
            </div>
          </div>
        </div>
        <div class="form-buttons">
          <ButtonCustomized label="Cancel" @click="closeModal" secondary />
          <ButtonCustomized :label="selectBtnTitle" @click="onSaveSelect" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import Dialog from '@/components/Dialog/Dialog.vue';
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import { reactive, ref } from 'vue';
import { orientationOptions } from '@/data/options/orientationOptions';
import { computed } from 'vue';
const props = defineProps({
  'btnTitle': {
    type: String,
    default: 'Select'
  },
  'selectBtnTitle': {
    type: String,
    default: 'Select'
  },
  'dialogTitle': {
    type: String,
    default: 'Select Orientation'
    // Change Orientation
  },
  'dialogSubtitle': {
    type: String,
    required: false
  },
  'orientation': {
    type: Number
  }
})
const emit = defineEmits(['cancel', 'select', 'exit', 'fail'])
const dialogRef = ref();
defineExpose({
  open: () => dialogRef.value.openModal()
})
const selectedOrientationName = computed(() => orientationOptions.filter(item => item.value == selectedOrientation.value)?.[0]?.name ?? '');
const selectedOrientation = reactive<any>(props.orientation || {});

function selectOrientation(orientationOption: any) {
  Object.assign(selectedOrientation, {
    name: orientationOption.name,
    value: orientationOption.value
  })
}

function clearSelection() {
  delete selectedOrientation.name;
  delete selectedOrientation.value;
}

function onSaveSelect() {
  // Skip if no orientation skipped
  if(!selectedOrientation.name) {
    dialogRef.value.closeModal();
    return;
  }
  const selectedOrientationPrepared = {
    name: selectedOrientation.name,
    id: selectedOrientation.value,
  }
  emit('select', selectedOrientationPrepared);
  dialogRef.value.closeModal();
  clearSelection();
}
</script>

<style lang="scss" scoped>
.orientation-link {
  &.with-btn-title {
    border: 0;
    cursor: pointer;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 6px;
    text-transform: uppercase;
    color: rgba(37, 41, 74, 0.5);
    font-weight: bold;
  }
}
.orientation-link:hover {
  text-decoration: underline;
  color: #93A5AE;
}

.active {
  background-color: #1c69d4;
  color: white
}

.active .orientation-lable {
  border-color: white;
  color: white;
}

.button {
  cursor: pointer;
}

.delete-item-form {
  display: flex;
  flex-direction: column;
  max-width: 30rem;
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

.orientation-editor {
  width: 90px;
  height: 100px;
  text-align: center;
  cursor: pointer;
}

.orientation-lable {
  border: 2px solid #262626;
  color: #262626;
  text-align: center;
}

.portrait {
  width: fit-content;
  padding: 8px
}

.rotate-180 {
  transform: rotate(-180deg);
}
</style>